// Lê configuração em runtime a partir de window._env_ (injetada pelo container
// via docker-entrypoint.sh, a partir do ConfigMap) e faz fallback para as
// variáveis de build (process.env). Assim a mesma imagem serve todos os
// ambientes, enquanto o dev local continua usando o .env.
export function getRuntimeConfig(key) {
  if (
    typeof window !== 'undefined' &&
    window._env_ &&
    window._env_[key] !== undefined &&
    window._env_[key] !== ''
  ) {
    return window._env_[key];
  }
  return process.env[key];
}

export default getRuntimeConfig;
